import { useState, useEffect } from "react";
import { DropdownButton, Dropdown, Accordion, Form } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../utils/constant";
import AgentModal from "../../components/Modals/AgentModel";
import ExportModal from "../../components/Modals/ExportsModel/main";
import ImportModal from "../../components/Modals/ImportModel";
import Loader from "../../components/Loader";
import { MdCancel, MdCheckCircle } from "react-icons/md";

import { BsThreeDotsVertical } from "react-icons/bs";
import {
  FaEdit,
  FaFileExport,
  FaFileImport,
  FaPlus,
  FaTrashAlt,
  FaUserCircle,
} from "react-icons/fa";
import { useCommonContext } from "../../utils/context";
import CommonButton from "../../components/CommonButton";
import Pagination from "../../components/Pagination";
import NoData from "../../components/NoData";
import ViewModal from "../../components/Modals/HisstoryModals/UserViewModel";

const Agent = () => {
  const [showAgentModal, setShowAgentModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [editAgentData, setEditAgentData] = useState(null);
  const [statusFilter, setStatusFilter] = useState(true);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);

  const role = localStorage.getItem("role");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showViewModal, setShowViewModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = agents;
  useEffect(() => {
    fetchAgents(currentPage);
  }, [currentPage, itemsPerPage, searchText, statusFilter]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);

  const fetchAgents = async (page = 1) => {
    setLoading(true);
    try {
      let url = `${BASE_URL}/users/tms_users/`;
      if (statusFilter === false) {
        url = `${BASE_URL}/users/tms_users/deactivate-users/`;
      }

      const response = await axios.get(url, {
        headers: HEADERS,
        params: {
          role: "agent",
          page: page,
          page_size: itemsPerPage,
          search: searchText || undefined,
          ...(statusFilter !== false && {
            is_active: statusFilter !== null ? statusFilter : undefined,
          }),
        },
      });

      if (response.data?.results) {
        setAgents(response.data.results);
        setTotalPages(response.data.total_pages);
        setCurrentPage(page);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleEditAgent = (agent) => {
    setEditAgentData(agent);
    setShowAgentModal(true);
  };

  const handleDeleteAgent = async (agentId) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/users/tms_users/${agentId}/`,
        {
          headers: {
            ...HEADERS,
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response) {
        toast.success("Executive deleted successfully!");
        fetchAgents(currentPage);
      } else {
        toast.error("Failed to delete Executive. Please try again.");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        } else {
          toast.error("Unexpected error format. Please try again.");
        }
      } else {
        toast.error("Error Please Try again.");
      }
    }
  };

  const handleToggleActive = async (agentId, currentStatus) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/users/tms_users/${agentId}/`,
        { is_active: !currentStatus },
        {
          headers: {
            ...HEADERS,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        toast.success(
          `Executive ${
            currentStatus ? "deactivated" : "activated"
          } successfully!`,
        );
        fetchAgents(currentPage);
      } else {
        toast.error("Failed to update Executive status. Please try again.");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        } else {
          toast.error("Unexpected error format. Please try again.");
        }
      } else {
        toast.error("Error Please Try again.");
      }
    }
  };

  const handleCloseModals = () => {
    setShowAgentModal(false);
    setShowImportModal(false);
    setEditAgentData(null);
  };

  const handleViewUser = (agent) => {
    setSelectedAgents(agent);
    setShowViewModal(true);
  };

  const handlePageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const handleAddUser = () => {
    setEditAgentData(null);
    setShowAgentModal(true);
  };

  return (
    <div className="container-fluid ">
      <div className="mt-3 d-flex container-header flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
        <h4 className="mb-2 mb-md-0">Executives</h4>

        <div className="d-none d-md-flex align-items-center gap-2">
          <Form.Control
            type="text"
            placeholder="Search Here..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="uniform-input search-text"
          />

          <Form.Select
            value={
              statusFilter === true
                ? "is_active"
                : statusFilter === false
                  ? "!is_active"
                  : ""
            }
            onChange={(e) => {
              const value = e.target.value;
              if (value === "is_active") {
                setStatusFilter(true);
              } else if (value === "!is_active") {
                setStatusFilter(false);
              } else {
                setStatusFilter(null);
              }
            }}
            className="uniform-input"
          >
            <option value="is_active">Active</option>
            <option value="!is_active">Inactive</option>
          </Form.Select>

          <CommonButton
            className="uniform-button"
            onClick={() => setShowAgentModal(true)}
          >
            <FaPlus className="me-1" /> Add
          </CommonButton>

          <CommonButton className="uniform-button" onClick={() => setShowImportModal(true)}>
            <FaFileImport className="me-1" /> Import
          </CommonButton>

          <CommonButton
            className="uniform-button"
            onClick={() => setShowExportModal(true)}
            disabled={currentItems.length === 0}
          >
            <FaFileExport className="me-1" />{" "}
            {exportLoading ? "Exporting..." : "Export"}
          </CommonButton>
        </div>

        <div className="d-md-none w-100">
          <Accordion flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Filters & Actions</Accordion.Header>
              <Accordion.Body className="pt-3">
                <Form.Control
                  type="text"
                  placeholder="Search Here..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  className="uniform-input search-text mb-3"
                />

                <Form.Select
                  value={
                    statusFilter === true
                      ? "is_active"
                      : statusFilter === false
                        ? "!is_active"
                        : ""
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "is_active") {
                      setStatusFilter(true);
                    } else if (value === "!is_active") {
                      setStatusFilter(false);
                    } else {
                      setStatusFilter(null);
                    }
                  }}
                  className="uniform-input mb-3"
                >
                  <option value="is_active">Active</option>
                  <option value="!is_active">Inactive</option>
                </Form.Select>

                <div className="row g-2 mt-2">
                  <div className="col-12 col-sm-6 col-md-4">
                    <CommonButton
                      className="uniform-button w-100 d-flex justify-content-center align-items-center"
                      onClick={() => setShowAgentModal(true)}
                    >
                      <FaPlus className="me-1" /> Add
                    </CommonButton>
                  </div>

                  <div className="col-12 col-sm-6 col-md-4">
                    <CommonButton
                      className="uniform-button w-100 d-flex justify-content-center align-items-center"
                      onClick={handleAddUser}
                    >
                      <FaFileImport className="me-1" /> Import
                    </CommonButton>
                  </div>

                  <div className="col-12 col-sm-6 col-md-4">
                    <CommonButton
                      className="uniform-button w-100 d-flex justify-content-center align-items-center"
                      onClick={() => setShowExportModal(true)}
                      disabled={currentItems.length === 0}
                    >
                      <FaFileExport className="me-1" />{" "}
                      {exportLoading ? "Exporting..." : "Export"}
                    </CommonButton>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      <div
        className={`table-responsive ${
          currentItems.length === 0 ? "" : "tabell"
        } `}
      >
        {loading ? (
          <Loader />
        ) : currentItems.length > 0 ? (
          <table className="table tstart">
            <thead className="thead">
              <tr>
                <th style={{ width: "350px" }}>Name</th>
                <th style={{ width: "250px" }}>Email</th>
                <th style={{ width: "250px" }}>Phone</th>
                <th style={{ width: "200px" }}>Date of Joining</th>
                <th style={{ width: "200px" }}>Casual Leaves</th>
                <th style={{ width: "200px" }}>Sick Leaves</th>
                <th style={{ width: "200px" }}>Punch-In Time</th>
                <th style={{ width: "200px" }}>Punch-Out Time</th>
                <th style={{ width: "200px" }}>Status</th>
                <th style={{ width: "150px" }}>Latitude</th>
                <th style={{ width: "150px" }}>Longitude</th>
                <th style={{ width: "150px" }}>GPS Status</th>
                <th style={{ width: "150px" }}></th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((agent, index) => (
                <tr
                  key={agent.id}
                  onClick={() => handleViewUser(agent)}
                  style={{
                    background: index % 2 === 0 ? "#f2f2f2" : "#fff",
                  }}
                >
                  <td>
                    <div className="d-flex align-items-center ">
                      <span className="badge bg-primary text-white me-2 emp-id-badge">
                        {agent.emp_id || "—"}
                      </span>
                      {agent.profile_image ? (
                        <img
                          src={agent.profile_image}
                          alt="Profile"
                          className="rounded-circle border me-2"
                          style={{ width: "30px", height: "30px" }}
                        />
                      ) : (
                        <FaUserCircle size={30} className="text-primary me-2" />
                      )}
                      <div
                        title={`${agent.first_name || "—"} ${
                          agent.last_name || "—"
                        }`}
                        className="tdsubject"
                      >
                        {agent.first_name || "—"} {agent.last_name || "—"}
                      </div>
                    </div>
                  </td>
                  <td>{agent.email || "—"}</td>
                  <td>{agent.phone_number || "—"}</td>
                  <td>{agent.date_joined || "—"}</td>
                  <td>
                    <div
                      title={agent.allocated_casual_leave || "—"}
                      className="tdsubject"
                    >
                      {agent.allocated_casual_leave || "—"}
                    </div>
                  </td>
                  <td>
                    <div
                      title={agent.allocated_sick_leave || "—"}
                      className="tdsubject"
                    >
                      {agent.allocated_sick_leave || "—"}
                    </div>
                  </td>
                  <td>
                    <div
                      title={
                        agent.today_attendance?.punch_in
                          ? formatTime(agent.today_attendance?.punch_in)
                          : "—"
                      }
                      className="tdsubject"
                    >
                      {agent.today_attendance?.punch_in
                        ? formatTime(agent.today_attendance?.punch_in)
                        : "—"}
                    </div>
                  </td>
                  <td>
                    <div
                      title={
                        agent.today_attendance?.punch_out
                          ? formatTime(agent.today_attendance?.punch_out)
                          : "—"
                      }
                      className="tdsubject"
                    >
                      {agent.today_attendance?.punch_out
                        ? formatTime(agent.today_attendance?.punch_out)
                        : "—"}
                    </div>
                  </td>

                  <td>
                    {agent.today_attendance?.status || "NA"}
                    <br />
                    <span
                      className={`badge ${
                        agent.is_active ? "bg-success" : "bg-danger"
                      }`}
                    >
                      {agent.is_active ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td>
                    <div
                      title={agent.longitude ? `${agent.longitude}` : "—"}
                      className="tdsubject"
                    >
                      {agent.longitude ? `${agent.longitude}` : "—"}
                    </div>
                  </td>
                  <td>
                    <div
                      title={agent.latitude ? `${agent.latitude}` : "—"}
                      className="tdsubject"
                    >
                      {agent.latitude ? `${agent.latitude}` : "—"}
                    </div>
                  </td>
                  <td>{agent.gps_status ? "On" : "Off"}</td>
                  <td>
                    <div className="ms-auto">
                      <DropdownButton
                        id="dropdown-basic-button"
                        title={<BsThreeDotsVertical />}
                        variant="link"
                        onClick={(e) => e.stopPropagation()}
                        className="p-0 text-secondary custom-dropdown"
                      >
                        <Dropdown.Item
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditAgent(agent);
                          }}
                        >
                          <FaEdit className="me-2" /> Edit
                        </Dropdown.Item>

                        {role === "admin" && (
                          <Dropdown.Item
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteAgent(agent.id);
                            }}
                          >
                            <FaTrashAlt className="me-2" /> Delete
                          </Dropdown.Item>
                        )}

                        <Dropdown.Item
                          onClick={(e) => {
                            e.stopPropagation();
                            handleToggleActive(agent.id, agent.is_active);
                          }}
                        >
                          {agent.is_active ? (
                            <>
                              <MdCancel className="me-2" /> Deactivate
                            </>
                          ) : (
                            <>
                              <MdCheckCircle className="me-2" /> Activate
                            </>
                          )}
                        </Dropdown.Item>
                      </DropdownButton>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <NoData message="No Data Found" height="400px" />
        )}
      </div>

      {currentItems.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          handlePageClick={handlePageClick}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      {showAgentModal && (
        <AgentModal
          show={showAgentModal}
          handleClose={handleCloseModals}
          agentData={editAgentData}
          fetchAgents={() => fetchAgents(currentPage)}
          roletype="agent"
        />
      )}

      <ExportModal
        show={showExportModal}
        handleClose={() => setShowExportModal(false)}
        title="agents"
      />

      <ViewModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        userId={selectedAgents?.id}
        user={selectedAgents}
      />

      {showImportModal && (
        <ImportModal
          show={showImportModal}
          handleClose={handleCloseModals}
          type="agents"
          onSuccess={() => fetchAgents(currentPage)}
        />
      )}
    </div>
  );
};

export default Agent;
